import * as React from 'react';
import {faExclamationCircle} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {FormEvent, Ref, useState} from 'react';

export interface TextAreaProps {
    className?: string;
    defaultValue?: string;
    cols?: number;
    disabled?: boolean;
    displayCounter?: boolean;
    error?: string;
    id?: string;
    maxLength?: number;
    name: string;
    onChange?: any;
    onKeyDown?: any;
    parentCSS?: string;
    placeholder: string;
    ref?: Ref<unknown> | null;
    required?: boolean;
    rows?: number;
    style?: React.CSSProperties;
    value?: string | string[];
}

export const TextAreaControl = (
    {
        className = ``,
        cols,
        defaultValue,
        disabled = false,
        displayCounter = false,
        error,
        id,
        maxLength = 900,
        name = ``,
        onChange,
        onKeyDown,
        parentCSS = ``,
        placeholder,
        required,
        rows = 4,
        style,
        value,
    }: TextAreaProps,
    ref,
) => {
    const initialLength = typeof value === `string` ? value.length : 0;
    const [characterCount, setCharacterCount] = useState(initialLength);

    /**
     * Template
     */
    return (
        <div className="tw-mb-3">
            <div className={`tw-mb-0 tw-relative ${parentCSS}`}>
                <textarea
                    className={`tw-block tw-rounded-sm tw-pt-2 tw-px-3 tw-w-full tw-border-solid focus:tw-ring-2 ${
                        error
                            ? 'tw-border-2 !tw-border-red-500 focus:tw-border-red-500 focus:tw-ring-red-300'
                            : 'tw-border tw-border-gray-200 focus:tw-border-gray-600 focus:tw-ring-sky-200'
                    } tw-appearance-none focus:tw-outline-none ${
                        disabled ? 'tw-bg-gray-100 tw-cursor-not-allowed tw-text-gray-400' : 'tw-bg-white tw-text-gray-900'
                    } ${className} `.trim()}
                    cols={cols}
                    defaultValue={defaultValue}
                    id={id}
                    maxLength={maxLength}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    onInput={(e: FormEvent<HTMLTextAreaElement>) => setCharacterCount(e.currentTarget.value.length)}
                    placeholder={`${placeholder} ${required ? '*' : ''}`}
                    ref={ref}
                    rows={rows}
                    style={style}
                    value={value}
                    name={name}
                />
                {error && (
                    <FontAwesomeIcon
                        className="tw-absolute tw-right-3 tw-text-red-500 tw-my-auto tw-top-[50%] tw-bottom-[50%]"
                        icon={faExclamationCircle}
                        size="lg"
                    />
                )}
            </div>
            <div className={'tw-flex tw-justify-between'}>
                {error && <label className="tw-text-red-500 tw-text-sm tw-static tw-mt-1">{error}</label>}
                {!error && <div />}
                {displayCounter && (
                    <span className="tw-text-left tw-justify-self-end">
                        <span className="tw-text-sm tw-text-gray-400">
                            {characterCount} / {maxLength}
                        </span>
                    </span>
                )}
            </div>
        </div>
    );
};
export const TextArea = React.forwardRef(TextAreaControl);
